<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" :fill="fillColor" xmlns="http://www.w3.org/2000/svg"
        :class="className">
        <path
            d="M12 4L2.85586 8.43352C2.10423 8.79795 2.10423 9.86872 2.85587 10.2331L11.5637 14.4551C11.8392 14.5887 12.1608 14.5887 12.4363 14.4551L19.5637 10.9988C20.2278 10.6767 21 11.1604 21 11.8985V15.4444C21 15.9967 21.4477 16.4444 22 16.4444C22.5523 16.4444 23 15.9967 23 15.4444V9.33333M6.43644 13.7457C5.77231 13.4235 5 13.9073 5 14.6454V15.9781C5 16.3612 5.21887 16.7106 5.56356 16.8778L11.5636 19.7883C11.8392 19.922 12.1608 19.922 12.4364 19.7883L18.4364 16.8778C18.7811 16.7106 19 16.3612 19 15.9781V14.6454C19 13.9073 18.2277 13.4235 17.5636 13.7457L12.4364 16.2327C12.1608 16.3664 11.8392 16.3664 11.5636 16.2327L6.43644 13.7457Z"
            :fill="fillColor" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StudyIcon',
    props: {
        fillColor: {
            type: String,
            default: '#fff'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        class: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const className = props.class;
        return {
            className
        };
    }
});
</script>